// removed by extract-text-webpack-plugin
module.exports = {"messagePlaceholder":"_3bbYGSnAgME6OWnYxxM9du","loadingMessage":"q7i2TM0ubk4UEu8N34uTP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadHeaderContainer/MessageThreadHeaderContainer.css
// module id = 1343
// module chunks = 0